module.exports = __webpack_public_path__ + "static/img/img-ptfw4.cc4e194.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw4.png
// module id = bZ60
// module chunks = 0